import { Ciudad } from '../facturacion/Ciudad';

export class Contacto{
    id: string;
    nombreCompleto: string;
    telefono: string;
    email: string;
    ciudad: Ciudad;
}